var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDisplayName, findInstrument } from "@domains/utils/displayName";
import { getDateInFormat } from "@domains/utils/reportDates";
export function ScripDetailMapper(data) {
    try {
        var limit = 5;
        var result = {
            events: data && data.events ? eventMapper(data.events) : {},
            news: data && data.news ? newsMapper(data.news, limit) : {},
            quote: data && data.quote ? quoteMapper(data.quote) : {},
            researchCall: data && data.rschCall ? researchCallMapper(data.rschCall, limit) : {},
        };
        return result;
    }
    catch (error) {
        console.log(error);
    }
}
var eventMapper = function (event) {
    return {
        displayName: createDisplayName(event),
        resultList: event.resLst.map(function (res) {
            return {
                date: getDateInFormat(res.date, "DD-MMM-YY"),
                event: res.event,
                value: res.val.includes(":") ? "Ratio ".concat(res.val) : "\u20B9 ".concat(res.val),
            };
        }),
    };
};
var newsMapper = function (news, limit) {
    var _a, _b, _c;
    news.content = (_a = news === null || news === void 0 ? void 0 : news.content) === null || _a === void 0 ? void 0 : _a.slice(0, limit);
    return {
        first: news.first,
        last: news.last,
        number: news.number,
        size: news.size,
        symbol: news.symbol,
        totalElements: news.totalElements,
        totalPages: news.totalPages,
        date: news.content && ((_b = news.content) === null || _b === void 0 ? void 0 : _b.length) > 0
            ? getDateInFormat(news.content[0].date, "DD-MMM-YY")
            : "",
        content: (_c = news === null || news === void 0 ? void 0 : news.content) === null || _c === void 0 ? void 0 : _c.map(function (content) {
            return {
                category: content.category,
                date: getDateInFormat(content.date, "DD-MMM-YY"),
                description: content.desc,
                guid: content.guid,
                title: content.title,
                customElements: {
                    displayName: content.customElements.dpName,
                    highlightedText: content.customElements.hghlTxt,
                    symbol: content.customElements.sym,
                    tradeSymbol: content.customElements.trdSym,
                },
            };
        }),
    };
};
var quoteMapper = function (quote) {
    var _a, _b, _c, _d, _e, _f;
    return {
        research: quote.rchSt,
        marketDepth: {
            buyQty: quote.mkd.buyQty,
            sellQty: quote.mkd.sellQty,
            ask: quoteAskAndBidMaping(quote.mkd.ask),
            bid: quoteAskAndBidMaping(quote.mkd.bid),
            tableData: quoteTableMapping(quote.mkd.bid, quote.mkd.ask, (_a = quote === null || quote === void 0 ? void 0 : quote.qt) === null || _a === void 0 ? void 0 : _a.ltSz, quote.mkd.buyQty, quote.mkd.sellQty),
        },
        quoteObj: {
            close: quote.qt.c,
            low: quote.qt.l,
            open: quote.qt.o,
            high: quote.qt.h,
            chg: quote.qt.chg,
            chgP: quote.qt.chgP,
            desc: quote.qt.desc,
            isin: quote.qt.isin,
            sym: quote.qt.sym,
            exc: quote.qt.exc,
            lut: quote.qt.lut,
            ltp: quote.qt.ltp,
            trdSym: quote.qt.trdSym,
            dpNm: createDisplayName(quote.qt),
            dpVal: quote.qt.dpVal,
            dpName: quote.qt.dpNm,
            instrument: quote.asSym ? findInstrument(quote.asSym) : "",
            yrH: quote.qt.yrH,
            yrHDt: quote.qt.yrHDt,
            yrLw: quote.qt.yrLw,
            yrLwDt: quote.qt.yrLwDt,
            asTyp: quote.qt.asTyp,
            lotSize: (_b = quote === null || quote === void 0 ? void 0 : quote.qt) === null || _b === void 0 ? void 0 : _b.ltSz,
            optExc: quote.asSym ? findInstrument(quote.asSym, true) : "",
            dpInsTyp: (_c = quote === null || quote === void 0 ? void 0 : quote.qt) === null || _c === void 0 ? void 0 : _c.dpInsTyp,
            dpExpDt: (_d = quote === null || quote === void 0 ? void 0 : quote.qt) === null || _d === void 0 ? void 0 : _d.dpExpDt,
            opTyp: (_e = quote === null || quote === void 0 ? void 0 : quote.qt) === null || _e === void 0 ? void 0 : _e.opTyp,
            stkPrc: (_f = quote === null || quote === void 0 ? void 0 : quote.qt) === null || _f === void 0 ? void 0 : _f.stkPrc,
        },
    };
};
var researchCallMapper = function (data, limit) {
    var _a, _b;
    data.lst = (_a = data === null || data === void 0 ? void 0 : data.lst) === null || _a === void 0 ? void 0 : _a.slice(0, limit);
    return {
        currentSize: data.curSz,
        latestSize: data.lstSz,
        list: (_b = data.lst) === null || _b === void 0 ? void 0 : _b.map(function (item) {
            return {
                entryPrice: item.entryPrc,
                returnFromRC: item.rt,
                startDate: getDateInFormat(item.stDt, "DD-MMM-YY"),
                targetPriceOne: item.tgtPrc1,
                act: {
                    action: item.act.act,
                    displayAction: item.act.dpAct,
                    sentiment: item.act.sntmnt,
                },
            };
        }),
    };
};
var quoteAskAndBidMaping = function (list) {
    return list.map(function (item) {
        return {
            orders: item.no,
            price: item.price,
            quantity: item.qty,
        };
    });
};
var quoteTableMapping = function (bid, ask, lotSize, buyQty, sellQty) {
    var resultArr = [];
    var total = {
        bidOrderTotal: 0,
        bidQtyTotal: 0,
        askOrderTotal: 0,
        askQtyTotal: 0,
    };
    bid.forEach(function (item, i) {
        total.bidOrderTotal += +item.no;
        total.askOrderTotal += +ask[i].no;
        var mixup = {
            bidPrice: item.price,
            bidOrder: item.no,
            bidQuantity: lotSize
                ? (parseFloat(item.qty) / parseFloat(lotSize)).toString()
                : item.qty,
            askPrice: ask[i].price,
            askOrder: ask[i].no,
            askQuantity: lotSize
                ? (parseFloat(ask[i].qty) / parseFloat(lotSize)).toString()
                : ask[i].qty,
        };
        resultArr.push(mixup);
    });
    var lotSizeNumber = lotSize ? parseFloat(lotSize) : 1;
    total.bidQtyTotal =
        buyQty !== undefined ? parseFloat(buyQty) / lotSizeNumber : 0;
    total.askQtyTotal =
        sellQty !== undefined ? parseFloat(sellQty) / lotSizeNumber : 0;
    return { data: resultArr, total: total };
};
export var scriptDetailsStream = function (data, streaming) {
    var _a, _b;
    if (((_b = (_a = data === null || data === void 0 ? void 0 : data.quote) === null || _a === void 0 ? void 0 : _a.quoteObj) === null || _b === void 0 ? void 0 : _b.sym) === (streaming === null || streaming === void 0 ? void 0 : streaming.symbol)) {
        return __assign(__assign({}, data), { quote: __assign(__assign({}, data.quote), { quoteObj: __assign(__assign({}, data.quote.quoteObj), { chg: streaming.changePrice, chgP: streaming.changePercentage, high: streaming.high, low: streaming.low, ltp: streaming.curPrice, lut: streaming.updatedTime }) }) });
    }
    return data;
};
export var marketDepthStreamUpdate = function (data, streaming) {
    var _a, _b, _c, _d;
    if (((_b = (_a = data.quote) === null || _a === void 0 ? void 0 : _a.quoteObj) === null || _b === void 0 ? void 0 : _b.sym) === streaming.symbol) {
        return __assign(__assign({}, data), { quote: __assign(__assign({}, data.quote), { marketDepth: __assign(__assign({}, data.quote.marketDepth), { buyQty: streaming.totalBidQuantity, sellQty: streaming.totalAskquantity, tableData: quoteTableMapping(streaming.bidValues, streaming.askValues, (_d = (_c = data === null || data === void 0 ? void 0 : data.quote) === null || _c === void 0 ? void 0 : _c.quoteObj) === null || _d === void 0 ? void 0 : _d.lotSize, streaming.totalBidQuantity, streaming.totalAskquantity) }) }) });
    }
    return data;
};
